export enum VerticalAlignment {
  DEFAULT = 'default',
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
  JUSTIFY = 'justify',
}
